import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { isRarityStr } from '@sorare/core/src/lib/so5';

export const useMissionsPreferredRarity = () => {
  const { sport } = useSportContext();
  const { lifecycle } = useLifecycle();
  const preferredSportRarity = lifecycle?.missionsRarityFilter?.[sport];

  return isRarityStr(preferredSportRarity) && preferredSportRarity
    ? preferredSportRarity
    : Rarity.common;
};
